import { useTranslation } from 'react-i18next';

interface Props {
  message: string;
  links?: Link[];
  isHcpListing?: boolean;
}

export interface Link {
  label: string;
  url: string;
  speciality?: string;
}

function groupHcpsBySpecialities(links: Link[]): Map<string, Link[]> {
    const hcpsBySpecialities = links.reduce((acc, link) => {
        const speciality = link.speciality ?? 'GENERAL_MEDICINE';
        if (!acc.has(speciality)) {
            acc.set(speciality, []);
        }

        acc.get(speciality)!.push(link);
        return acc;
    }, new Map<string, Link[]>());

    return new Map([...hcpsBySpecialities.entries()].sort());
}

export default function ErrorScreen({ message, links, isHcpListing }: Props) {
  const { t } = useTranslation();

  console.log(groupHcpsBySpecialities(links || []));

  return (
    <div className="main-container wrap">
      <h1>{t('UI.ERROR.TITLE')}</h1>
      <p>{message}</p>

        {isHcpListing && links ? (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(320px,1fr))' }}>
                {
                    [...groupHcpsBySpecialities(links || []).entries()]
                        .map(([speciality, links]) => (
                            <div key={speciality}>
                                <h3>{t(`SPECIALITIES.${speciality}`)}</h3>
                                <ul className="links">
                                    {links.map(link => (
                                        <li key={link.url}>
                                            <a href={link.url}>{link.label}</a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))
                }
            </div>
        ) : (
            <ul className="links" style={{ marginTop: '2rem' }}>
                {links?.map((link, index) => (
                    <li key={index}>
                        <a href={link.url}>{link.label}</a>
                    </li>
                ))}
            </ul>
        )}
    </div>
  );
}
